import type { ReactNode } from "react";

import ThemeToggle from "./ThemeToggle";

/**
 * The chrome every public page shares: centred wordmark, theme switcher in
 * the page's corner, and a one-line footer. The page itself supplies the
 * narrow column (`<main className="station">`).
 */

export const Wordmark = () => (
  <a className="wordmark" href="/" aria-label="StreamLover home">
    StreamL
    <span className="o" aria-hidden="true" />
    ver
  </a>
);

const PageShell = ({ children }: { children: ReactNode }) => (
  <div className="stationpage">
    <header className="stationbar">
      <div className="stationbar__inner">
        <Wordmark />
      </div>
      {/* Outside the column on purpose: it rides the page's corner. */}
      <div className="stationbar__actions">
        <ThemeToggle />
      </div>
    </header>
    {children}
    <footer className="station__foot mono">
      <div>
        <a href="/">streamlover.app</a> · Live, human-picked radio
      </div>
      <div className="station__foot-legal">
        <a href="/terms">Terms</a> · <a href="/privacy">Privacy</a> ·{" "}
        <a href="/dmca">DMCA</a> · <a href="/delete-account">Delete account</a>
      </div>
    </footer>
  </div>
);

export default PageShell;
